import { imageProvider } from './config/imageProvider/imageProviderConfig';
import { redirect } from './redirect';

const version = new Date().getTime();
export const BASE_URL = process.env.BASE_API_URL;
export const TRANSPORTATION_API_URL = process.env.TRANSPORTATION_API_URL;
export const BASE_API_URL = `${BASE_URL}/api/`;
// eslint-disable-next-line max-len,vue/max-len
export const CONF_TOKEN = 'a26ac89e14e68c5f8f1e1246622b88ec83774411009035bbd95e614acebf9f553EuOp-e0m40lWWyqx8T7ZW6ToSLUFnVf';

export default {
  modern: process.env.ENVIRONMENT === 'production',
  server: {
    port: 3100,
    // host: '0.0.0.0',
  },
  // Global page headers: https://go.nuxtjs.dev/config-head
  head: {
    title: 'Транспортная компания - Central Trans',
    htmlAttrs: {
      lang: 'ru',
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { hid: 'metadescription', name: 'description', content: '' },
      // Гео-мета (региональность/координаты офиса); при необходимости перекрываются в layout
      { hid: 'geo-region', name: 'geo.region', content: 'RU-SVE' },
      { hid: 'geo-placename', name: 'geo.placename', content: 'Екатеринбург' },
      { hid: 'geo-position', name: 'geo.position', content: '56.8519;60.6122' },
      { hid: 'geo-icbm', name: 'ICBM', content: '56.8519, 60.6122' },
    ],
    link: [
      { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
      // fancybox отдаём локально (был внешний render-blocking запрос на cdn.jsdelivr.net)
      { rel: 'stylesheet', href: '/css/fancybox.css' },
      // прогрев DNS/TLS для сторонних скриптов (метрика, виджет звонков, коллтрекинг)
      { rel: 'preconnect', href: 'https://mc.yandex.ru', crossorigin: true },
      { rel: 'preconnect', href: 'https://widget.novofon.ru' },
      { rel: 'dns-prefetch', href: 'https://vpbx034305239.domru.biz' },
      { rel: 'dns-prefetch', href: 'https://cdn.botfaqtor.ru' },
      { rel: 'dns-prefetch', href: 'https://top-fwz1.mail.ru' },
      // reCAPTCHA грузится только при открытии окна проверки — прогреваем хотя бы DNS
      { rel: 'dns-prefetch', href: 'https://www.recaptcha.net' },
      { rel: 'dns-prefetch', href: 'https://www.gstatic.com' },
    ],
    script: [
      {
        hid: 'ld-organization',
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': ['Organization', 'MovingCompany'],
          'name': 'Central Trans',
          'alternateName': 'Транспортная компания Central Trans',
          'slogan': 'Грузоперевозки по России и СНГ с 2010 года',
          'description': 'Транспортная компания Central Trans (Централ Транс) — грузоперевозки по России и странам СНГ с 2010 года: генеральные, негабаритные, тяжеловесные грузы, перегон техники из Китая, ЖД и мультимодальные перевозки. Собственный автопарк, страхование груза, расчёт стоимости за минуту.',
          'url': 'https://centraltrans.ru/',
          'knowsAbout': [
            'Грузоперевозки',
            'Негабаритные грузы',
            'Тяжеловесные грузы',
            'Перевозка спецтехники',
            'Перегон техники из Китая',
            'Железнодорожные перевозки',
            'Мультимодальные перевозки',
            'Перевозка ЖБИ',
            'Контейнерные перевозки',
            'Разрешения на перевозку негабарита'
          ],
          'logo': {
            '@type': 'ImageObject',
            'url': 'https://centraltrans.ru/favicon.svg'
          },
          'email': 'hello@centraltrans.ru',
          'telephone': '+7 800 551 7490',
          'foundingDate': '2010',
          'address': {
            '@type': 'PostalAddress',
            'addressCountry': 'RU',
            'addressRegion': 'Свердловская область',
            'addressLocality': 'Екатеринбург',
            'postalCode': '620014',
            'streetAddress': 'ул. Хохрякова, 74, оф. 1001'
          },
          'geo': {
            '@type': 'GeoCoordinates',
            'latitude': 56.8519,
            'longitude': 60.6122
          },
          'openingHoursSpecification': [
            {
              '@type': 'OpeningHoursSpecification',
              'dayOfWeek': ['Mo', 'Tu', 'We', 'Th', 'Fr'],
              'opens': '08:00',
              'closes': '20:00'
            }
          ],
          'areaServed': [
            {'@type': 'Country', 'name': 'Россия'},
            {'@type': 'City', 'name': 'Екатеринбург'},
            {'@type': 'City', 'name': 'Москва'},
            {'@type': 'City', 'name': 'Санкт-Петербург'},
            {'@type': 'City', 'name': 'Челябинск'},
            {'@type': 'City', 'name': 'Тюмень'},
            {'@type': 'City', 'name': 'Новосибирск'},
            {'@type': 'City', 'name': 'Казань'},
            {'@type': 'City', 'name': 'Нижний Новгород'},
            {'@type': 'City', 'name': 'Пермь'},
            {'@type': 'City', 'name': 'Уфа'},
            {'@type': 'City', 'name': 'Омск'},
            {'@type': 'City', 'name': 'Самара'},
            {'@type': 'City', 'name': 'Красноярск'},
            {'@type': 'City', 'name': 'Краснодар'},
            {'@type': 'City', 'name': 'Ростов-на-Дону'},
            {'@type': 'City', 'name': 'Воронеж'},
            {'@type': 'City', 'name': 'Волгоград'},
            {'@type': 'City', 'name': 'Сургут'},
            {'@type': 'City', 'name': 'Нижний Тагил'},
            {'@type': 'Country', 'name': 'Казахстан'},
            {'@type': 'Country', 'name': 'Беларусь'},
            {'@type': 'Country', 'name': 'Армения'},
            {'@type': 'Country', 'name': 'Грузия'},
            {'@type': 'Country', 'name': 'Узбекистан'},
            {'@type': 'Country', 'name': 'Киргизия'}
          ],
          'sameAs': [
            'https://telegram.me/centraltranslogistics_bot',
            'https://wa.me/79920029001'
          ],
          'contactPoint': [
            {
              '@type': 'ContactPoint',
              'telephone': '+7 800 551 7490',
              'contactType': 'customer service',
              'areaServed': 'RU',
              'availableLanguage': ['ru']
            }
          ]
        },
      },
      {
        hid: 'ld-website',
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          'name': 'Central Trans',
          'alternateName': 'Транспортная компания Central Trans',
          'url': 'https://centraltrans.ru/',
          'potentialAction': {
            '@type': 'SearchAction',
            'target': 'https://centraltrans.ru/search?q={search_term_string}',
            'query-input': 'required name=search_term_string'
          }
        },
      },
      {type: 'text/javascript', body: true, src: '/js/sourcebuster.min.js', async: true},
      {type: 'text/javascript', body: false, src: 'https://widget.novofon.ru/novofon.js?k=dqgTo_Akr6eLuRcI9HyXKyp_iU8BBhOH', async: true},
    ],
  },

  // 404: правильные title/robots для страниц, которых нет в CMS
  // (Nuxt отдаёт 404 со стандартным layout, минуя layouts/error.vue).
  hooks: {
    'render:route': function (url, result, context) {
      const statusCode = context && context.res ? context.res.statusCode : null;

      if (statusCode === 404 && result && typeof result.html === 'string') {
        result.html = result.html
          .replace(/<title>[^<]*<\/title>/i, '<title>Страница не найдена - Central Trans</title>')
          .replace(/<\/head>/i, '<meta name="robots" content="noindex, follow"></head>');
      }
    },
  },

  // Global CSS: https://go.nuxtjs.dev/config-css
  css: [
    '~/static/fonts/fonts.scss',
    '~/assets/scss/main.scss'
  ],
  serverMiddleware: [
    '~/server-middleware/cache-handler',
    '~/server-middleware/seo-html',
  ],
  // Plugins to run before rendering page: https://go.nuxtjs.dev/config-plugins
  plugins: [
    {src: '~/plugins/yandex-cache-guard.client.js', mode: 'client'},
    {src: '~/plugins/lazy-images-fix.client.js', mode: 'client'},
    {src: '~/plugins/chunk-reload.client.js', mode: 'client'},
    { src: '~/plugins/Vuelidate.js' },
    { src: '~plugins/vue-range-slider.js', ssr: false },
    { src: '~plugins/fancyapps-ui.js', ssr: false },

    '~plugins/vue-mask.js',
    '~plugins/phone-format.js',
    '~plugins/number-format.js',
    '~plugins/case-words.js',
    '~plugins/get-cookies-opt.js',
    '~plugins/device.js',
    '~plugins/additional-block-classes.js',
    '~plugins/yaglaaction.js',
    '~plugins/checkRoutes.js',
    '~plugins/find-cms-id-by-nav-id.js',
  ],

  // Build Configuration: https://go.nuxtjs.dev/config-build

  // Modules for dev and build (recommended): https://go.nuxtjs.dev/config-modules
  buildModules: [

    // https://go.nuxtjs.dev/typescript
    '@nuxt/typescript-build',
    '@nuxtjs/google-analytics',
  ],
  // Modules: https://go.nuxtjs.dev/config-modules
  modules: [
    'cookie-universal-nuxt',
    '@nuxt/image',
    '@nuxtjs/style-resources',
    '@nuxtjs/toast',
    ['~/node_modules/sitis-nuxt/lib', {
      baseUrl: BASE_API_URL,
      // cmsRoot: 'cms' - default
    }],

    // Yandex Metrika
    [
      '@rkaliev/nuxtjs-yandex-metrika',
      {
        debug: false,

        id: 34965765,
        webvisor: true,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        ecommerce: 'dataLayer',
        disabled: Boolean(process.env.ENVIRONMENT !== 'production'),
      },
    ],

    ['@nuxtjs/redirect-module', { statusCode: 301 }],

    // reCAPTCHA
    ['@nuxtjs/recaptcha', {
      language: "ru",
      siteKey: "6Le1miUqAAAAAOFRe3tbV_Hf5xqAhcRTAFsevPXn",
      version: 2
    }],
  ],
  image: imageProvider(BASE_API_URL, TRANSPORTATION_API_URL),
  // '@nuxtjs/toast' config
  toast: {
    position: 'top-right',
    duration: 3000,
  },
  components: false,

  render: {
    bundleRenderer: {
      // шрифты не прелоадим: браузер сам подтягивает нужные веса из CSS (font-display: swap)
      // Прелоадим только каркасные чанки. Раньше в <head> уходило ~45 preload-ссылок
      // (все ленивые чанки компонентов/страниц) — на мобильном канале они забирали
      // полосу и LCP-картинка ждала. CSS и так грузится через <link rel=stylesheet>.
      shouldPreload: (file, type) => {
        if (type === 'style') return false;
        if (type !== 'script') return false;
        return /(^|\/)(app|runtime)[.-]/i.test(file)
          || /(^|\/)commons\/app/i.test(file)
          || /(^|\/)vendors\//i.test(file);
      },
    },
  },
  build: {
    extend(config, { isClient }) {
      // Extend only webpack config for client-bundle

      if (isClient) {
        config.devtool = 'source-map';
      }
    },
    filenames: {
      img: ({ isDev }) => isDev ? `[path][name].[ext]?v=${version}` : `img/[name].[contenthash:7].[ext]`,
      app: ({ isDev, isModern }) => isDev ? `[name]${isModern ? '.modern' : ''}.js?v=${version}` : `[contenthash:7]${isModern ? '.modern' : ''}.js`,
      chunk: ({ isDev, isModern }) => isDev ? `[name]${isModern ? '.modern' : ''}.js?v=${version}` : `[name]-[contenthash:7]${isModern ? '.modern' : ''}.js`,
      font: ({ isDev }) => isDev ? '[path][name].[ext]' : 'fonts/[name].[ext]',
      css: ({ isDev }) => isDev ? `[name].css?v=${version}` : `css/[contenthash:7].css`,
    },
    extractCSS: true,
    optimization: {
      runtimeChunk: 'single',
      splitChunks: {
        chunks: 'all',

        maxInitialRequests: 25,
        minSize: 15000,
        cacheGroups: {
          // Критический CSS — одним файлом; стили ленивых чанков остаются отдельными
          styles: {
            name: 'styles',
            test: /\.(css|scss|sass|vue)$/,
            chunks: 'initial',
            enforce: true,
            priority: 30,
          },
          vendor: {
            test: /[\\/]node_modules[\\/]/,
            name(module) {
              const packageName = module.context.match(/[\\/]node_modules[\\/](.*?)([\\/]|$)/)[1];
              return `npm.${packageName.replace('@', '')}`;
            },
          },
        },
      },
    },
  },

  router: {
    extendRoutes(routes, resolve) {
      // Посадчные страницы по городам
      routes.unshift({
        path: '/ural/:slug',
        components: {
          default: resolve(__dirname, 'pages/cargo-landing/_.vue'),
        },
        chunkNames: {
          default: 'cargo-landing-ural',
        },
      });

      routes = routes.sort((a, b) => {
        if (a.path < b.path) {
          return 1;
        }
        if (a.path > b.path) {
          return -1;
        }
        return 0;
      });
    },
  },
  env: {
    baseApiUrl: process?.env?.BASE_API_URL,
    pageAliasPolicy: process.env?.PAGE_ALIAS_POLICY || '/policy',
    cmsPageIdHowWorkBlock: process?.env?.CMS_PAGE_ID_HOW_WORK_BLOCK || '294',
    cmsPageIdOurExperinceBlock: process?.env?.CMS_PAGE_ID_OUR_EXPERIENCE_ID || '295',
    yandexApiKey: process.env?.YANDEX_API_KEY || 'e86ae4b7-8768-47e6-8b40-e3fd437c508a',
    freightPriceMultiplier: process?.env?.FREIGHT_PRICE_MULTIPLE || '0.1',
    baseCookieDomain: process.env.BASE_COOKIE_DOMAIN,

    cmsPageIdGruzopodemnost: process.env.CMS_PAGE_ID_GRUZOPODEMNOST || '163',
    cmsPageIdOtrasli: process.env.CMS_PAGE_ID_OTRASLI || '162',
    cmsPageIdTipGruza: process.env.CMS_PAGE_ID_TIP_GRUZA || '161',
    dadataToken: process?.env.DADATA_TOKEN || '',
  },

  // googleAnalytics: {
  //   id: process.env.GOOGLE_ANALYTICS_ID || 'UA-22235063-11',
  //   dev: Boolean(process.env.ENVIRONMENT !== 'production'),
  // },

  redirect,
};
